import { Component, Input } from '@angular/core';
import { MessageService } from '../../../../../../../shared/services/helpers/message-service/message.service';
import { ShootProofDataProvider } from '../../../../../../../shared/services/integrations/shootProof/shootProof.data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';

@Component({
	selector: 'delete-confirmation-modal',
	template: require('./delete-confirmation.modal.html'),
	styles: [require('./delete-confirmation.modal.scss')]
})
export class DeleteConfirmationModal {
	@Input('deleteGalleryId')
	set deleteGalleryId(value) {
		this._deleteGalleryId = value;
	}
	get deleteGalleryId() {
		return this._deleteGalleryId;
	}

	_deleteGalleryId: number;
	deleteGalleryFromShootProofAndSNSpinner = false;

	constructor(
		private shootProofDataService: ShootProofDataProvider,
		private messageService: MessageService,
		private activeModal: NgbActiveModal
	) {}

	deleteGalleryFromShootProofAdnSN(): void {
		this.deleteGalleryFromShootProofAndSNSpinner = true;
		this.deleteGallery();
	}

	onDismiss(): void {
		this.activeModal.close(false);
	}

	private deleteGallery(): void {
		this.shootProofDataService
			.removeJobGalleryV1(this.deleteGalleryId, true)
			.pipe(
				finalize(() => (this.deleteGalleryFromShootProofAndSNSpinner = false))
			)
			.subscribe(
				(): void => this.successDeleteGallery(),
				(error): void => this.messageService.handleError(error)
			);
	}

	private successDeleteGallery(): void {
		this.activeModal.close();
		this.messageService.showToaster('s_5', 'shootProof');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/integrations/connect-galleries/modals/delete-confirmation-modal/delete-confirmation.modal.ts